/**
 * User preference: glitch effects on or off across threshold pages (404, Login, Apply, Onboarding, Reset Password).
 * Stored in localStorage; GlitchSwitch toggles it. When false, GlitchWord and GlitchTerminal render plain text.
 *
 * Branding override: when a portal_branding scope sets glitch_effects_enabled = false, GlitchWord is
 * disabled for all users under that scope regardless of their personal preference.
 */

export const GLITCH_ENABLED_STORAGE_KEY = "luster_glitch_enabled"
export const GLITCH_ENABLED_CHANGE_EVENT = "luster_glitch_enabled_change"
export const BRANDING_GLITCH_CHANGE_EVENT = "luster_branding_glitch_change"

const DEFAULT = true

let brandingGlitchEnabled = true

export function getBrandingGlitchEnabled(): boolean {
  return brandingGlitchEnabled
}

export function setBrandingGlitchOverride(value: boolean): void {
  if (brandingGlitchEnabled === value) return
  brandingGlitchEnabled = value
  window.dispatchEvent(new CustomEvent(BRANDING_GLITCH_CHANGE_EVENT, { detail: value }))
}

export function getGlitchEnabled(): boolean {
  if (typeof window === "undefined") return DEFAULT
  if (!brandingGlitchEnabled) return false
  const raw = localStorage.getItem(GLITCH_ENABLED_STORAGE_KEY)
  if (raw == null) return DEFAULT
  return raw === "true"
}

export function setGlitchEnabled(value: boolean): void {
  localStorage.setItem(GLITCH_ENABLED_STORAGE_KEY, String(value))
  window.dispatchEvent(new CustomEvent(GLITCH_ENABLED_CHANGE_EVENT, { detail: value }))
}
